import { combineReducers, configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import employerReducer from "./employerReducer/employerSlice";
import contractReducer from "./contractReducer/contractSlice";
import createSagaMiddleware from "@redux-saga/core";
import kanbanReducer  from "./kanbanReducer/kanbanSlice";
import sidebarReducer from "./sidebarReducer/sidebarSlice";
import topbarReducer from "./topbarReducer/topbarSlice";

const reducer = {
	employer: employerReducer,
	contract: contractReducer,
	kanban: kanbanReducer,
	sidebar: sidebarReducer,
	topbar: topbarReducer,
};
const sagaMiddleware = createSagaMiddleware()
export const store = configureStore({
	reducer,
	middleware: gDM => gDM().concat(logger, sagaMiddleware),
});

// sagaMiddleware.run(rootSaga )